import React from 'react';
import { BrainCircuit, Target, CheckSquare, LayoutDashboard, Sparkles, Gamepad2 } from 'lucide-react';
export function FeaturesGrid() {
  const categories = [{
    title: 'Adaptief Systeem',
    icon: <BrainCircuit className="w-6 h-6" data-id="element-14" />,
    color: 'text-orange-600',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    features: [{
      name: 'Adaptieve Engine',
      desc: 'Past niveau automatisch aan (16 tiers B6 t/m E8+).'
    }, {
      name: 'Mastery Tracking',
      desc: 'Continue beheersingsmeting met confidence-scores.'
    }, {
      name: 'Mastery Decay',
      desc: 'Ingebouwde vergeetcurve herinnert aan herhaling.'
    }, {
      name: 'Placement Test',
      desc: 'Automatische niveaubepaling bij de start.'
    }]
  }, {
    title: 'Leermodi',
    icon: <Target className="w-6 h-6" data-id="element-15" />,
    color: 'text-amber-600',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    features: [{
      name: 'Gemengd Oefenen',
      desc: "Fluency mode gericht op de 'sweet spot' (50-80%)."
    }, {
      name: 'Gericht Oefenen',
      desc: 'Sprint mode voor intensief drillen op zwakke punten.'
    }, {
      name: 'Uitdaging',
      desc: 'Challenge mode met vragen boven huidig niveau.'
    }, {
      name: 'Learning Lab',
      desc: 'Centraal startpunt met slimme aanbevelingen.'
    }]
  }, {
    title: 'Toetsen & Rapportage',
    icon: <CheckSquare className="w-6 h-6" data-id="element-16" />,
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    features: [{
      name: 'Cito-achtige Toetsen',
      desc: 'Gestandaardiseerd met 30 vragen en tijdslimiet.'
    }, {
      name: 'Leerlingprofiel',
      desc: 'Geschat niveau, groei-indicatoren en actieplan.'
    }, {
      name: 'Toetsgeschiedenis',
      desc: 'Bekijk eerdere resultaten en volg groei over tijd.'
    }]
  }, {
    title: 'Visuele Hulpmiddelen',
    icon: <LayoutDashboard className="w-6 h-6" data-id="element-17" />,
    color: 'text-blue-600',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    features: [{
      name: '15+ Interactieve Visuals',
      desc: 'Getallenlijnen, breukenbalken, klokken, etc.'
    }, {
      name: 'Stimulus & Support',
      desc: 'Visuals getoond tijdens vraag of na fout antwoord.'
    }]
  }, {
    title: 'Vraagtypen',
    icon: <Sparkles className="w-6 h-6" data-id="element-18" />,
    color: 'text-purple-600',
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    features: [{
      name: '15+ Vraagtypen',
      desc: 'Drag-and-drop, grafieken, tabellen, invullen, etc.'
    }, {
      name: 'Rijke Feedback',
      desc: 'Stapsgewijze oplossingen en distractor-feedback.'
    }]
  }, {
    title: 'Gamificatie',
    icon: <Gamepad2 className="w-6 h-6" data-id="element-19" />,
    color: 'text-rose-600',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    features: [{
      name: 'XP & Levels',
      desc: 'Verdien punten, stijg in level met confetti-vieringen.'
    }, {
      name: 'Ademhalingsoefening',
      desc: 'Kalmeringstechniek voor stressvrij toetsen.'
    }]
  }];
  return <section className="py-16 lg:py-24 bg-[#fffbf5]" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="max-w-2xl mb-16 text-center mx-auto" data-id="element-22">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-950 mb-4 tracking-tighter" data-id="element-23">
            De Krachtcentrale ⚡️
          </h2>
          <p className="text-lg text-slate-600" data-id="element-24">
            Een uitgebreid overzicht van de features die Meester djay het meest
            geavanceerde leerplatform maken.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-25">
          {categories.map((category, idx) => <div key={idx} className={`${category.bg} border ${category.border} rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1`} data-id="element-26">
              <div className="flex items-center gap-3 mb-6" data-id="element-27">
                <div className={`w-12 h-12 rounded-xl bg-white flex items-center justify-center ${category.color} shadow-sm`} data-id="element-28">
                  {category.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-950" data-id="element-29">
                  {category.title}
                </h3>
              </div>
              <ul className="space-y-4" data-id="element-30">
                {category.features.map((feature, fIdx) => <li key={fIdx} className="flex flex-col" data-id="element-31">
                    <span className="font-bold text-slate-900 text-sm mb-1" data-id="element-32">
                      {feature.name}
                    </span>
                    <span className="text-slate-700 text-sm leading-relaxed" data-id="element-33">
                      {feature.desc}
                    </span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}